import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { Event } from "../Event";
dayjs.extend(utc)

export class SaleEvents extends Event {
    public onLoad = async () => {
        const { url } = this.globalProps.match;

        this.setState("loadings", ["sale_date"])
        if (url.includes("/add")) {
            this.setFieldValue("sale_date", dayjs().format('YYYY-MM-DD HH:mm'));
        } else if (typeof this.values.sale_date == 'string') {
            this.setFieldValue("sale_date", dayjs(this.values.sale_date).format('YYYY-MM-DD HH:mm'));
        }

        setTimeout(() => this.setState("loadings", []), 500)
    }
}
